import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration from config file

/**
 * Class representing the view for managing partner providers.
 * @extends JetView
 */
export default class tablePartnersProviderView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        // Configuration for the double list component
        var list1 = {
            view: 'dbllist', // Double list view
            id: 'dbllist', // Unique identifier for the double list
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Proveedores no agregados'), // Left label for unadded providers
            labelRight: _('Proveedores Agregados'), // Right label for added providers
            data: [], // Initial data for the list
        };

        // Return the main form configuration
        return {
            view: 'form', // Form view
            id: 'f1', // Unique identifier for the form
            rows: [
                {
                    view: 'forminput', // Input field for the form
                    name: 'access', // Name of the input field
                    body: list1, // Body of the input field containing the double list
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Alignment of the label
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var values = ''; // Variable to hold values of included providers
        var string1 = ''; // Variable to hold query string for API requests

        // Event listener for filtering partner providers
        this.on(this.app, 'partnerProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ''; // Reset query string

            // Iterate through filter data entries
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filter parameters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clear the double list and set its value to empty
            $$('dbllist').$$('left').clearAll();
            $$('dbllist').setValue([]);

            // AJAX request to fetch partner providers based on filters
            webix.ajax().get(devConfig.geturlApi() + 'PartnersProviders/GetGroupPartnersProviders', string1, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse response data
                    if (!data.HasError) {
                        // If no error in response
                        $$('dbllist').$$('left').clearAll(); // Clear the left list
                        $$('dbllist').setValue([]); // Reset the value of the double list
                        $$('dbllist').parse(data.Data.ExcludedProvidersList); // Parse excluded providers into the list
                        $$('dbllist').setValue(data.Data.IncludedProvidersList); // Set included providers in the list
                        values = data.Data.IncludedProvidersList; // Store included providers
                    } else {
                        webix.message('Error! '); // Show error message if there's an error
                    }
                },
            });
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            var array1 = values.split(','); // Split included providers into an array
            var array2 = $$('dbllist').getValue().split(','); // Split current values into an array
            var arrayAgregados = []; // Array to hold newly added providers
            var arrayEliminados = []; // Array to hold removed providers

            // Identify newly added providers
            array2.forEach(function (obj) {
                var found = array1.find(function (element) {
                    return element == obj; // Check if the provider was previously included
                });
                if (found == undefined) {
                    arrayAgregados.push(obj); // Add to newly added providers if not found
                }
            });

            // Identify removed providers
            array1.forEach(function (obj) {
                var found = array2.find(function (element) {
                    return element == obj; // Check if the provider is still included
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // Add to removed providers if not found
                }
            });


            // Create a confirmation window for the user
            webix
                .ui({
                    view: 'window', // Window view
                    head: {
                        view: 'toolbar', // Toolbar for the window
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        view: 'form', // Form inside the window
                        id: 'form', // Unique identifier for the form
                        elements: [
                            {
                                view: 'text', // Text input for observations
                                label: _('Observación'), // Label for the input
                                name: 'Note', // Name of the input
                                required: true, // Not required
                                labelWidth: 100, // Width of the label
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'), // Button label
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('form').setValues($$('form').getCleanValues()); // Reset form values
                                            // AJAX request to refresh the double list
                                            webix
                                                .ajax()
                                                .get(
                                                    devConfig.geturlApi() +
                                                        'PartnersProviders/GetGroupPartnersProviders',
                                                    string1,
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Show error message on failure
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var data = JSON.parse(text); // Parse response data
                                                            if (!data.HasError) {
                                                                $$('dbllist').$$('left').clearAll(); // Clear the left list
                                                                $$('dbllist').setValue([]); // Reset the value of the double list
                                                                $$('dbllist').parse(data.Data.ExcludedProvidersList); // Parse excluded providers into the list
                                                                $$('dbllist').setValue(data.Data.IncludedProvidersList); // Set included providers in the list
                                                                values = data.Data.IncludedProvidersList; // Store included providers
                                                            } else {
                                                                webix.message('Error! '); // Show error message if there's an error
                                                            }
                                                        },
                                                    },
                                                );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form', // Button type
                                        value: _('Guardar'), // Button label
                                        click: function ($e) {
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                // Validate the form
                                                var vthis = this; // Reference to the current button instance
                                                this.getTopParentView().hide(); // Hide the window
                                                // AJAX request to save the changes
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() +
                                                            'PartnersProviders/SaveGroupPartnersProviders',
                                                        '{"Partner":"' +
                                                            id_partner +
                                                            '","IncludedProvidersList":"' +
                                                            arrayAgregados +
                                                            '","ExcludedProvidersList":"' +
                                                            arrayEliminados +
                                                            '","Note":"' +
                                                            valuesForm.Note +
                                                            '"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Show error message on failure
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(text); // Parse response data
                                                                if (!data.HasError) {
                                                                    webix.message(_('Proveedor Partner Editado')); // Show success message
                                                                    values = $$('dbllist').getValue(); // Update values with current selection
                                                                } else {
                                                                    webix.message(_('Error! ')); // Show error message if there's an error
                                                                }
                                                                vthis.getTopParentView().hide(); // Hide the window
                                                            },
                                                        },
                                                    );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error title
                                                    type: 'alert-error', // Error type
                                                    text: _('Completa los campos...'), // Error message
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate the form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
